// components/settingsModal/SettingsModal.js

import React, { useState, useEffect } from 'react';
import Profile from './Profile';
import Contacts from './Contacts';
import CallHistory from './CallHistory';
import FlaggedCalls from './FlaggedCalls';
import Legal from './Legal';
import { doc, getDoc } from 'firebase/firestore';  // Import Firestore methods
import { db } from '../../FirebaseConfig';  // Import Firebase config
import './SettingsModal.css'; // Import your CSS for styling
import { useContext } from 'react';
import { AppContext } from '../auth/AppContext';

const SettingsModal = ({ 
  isVisible, 
  onClose, 
  currentUser, 
  activeTab, 
  isPhoneAgentMode,
  setIsPhoneAgentMode,
  setPhoneAgentInstructions
}) => {
  const [tab, setTab] = useState(activeTab || 'profile');
  const [userPhoneNumber, setUserPhoneNumber] = useState('');
  const [historyFilter, setHistoryFilter] = useState(null);

  useEffect(() => {
    setTab(activeTab); // Update the tab when activeTab prop changes
  }, [activeTab]);

  useEffect(() => {
    const fetchUserPhoneNumber = async () => {
      if (currentUser) {
        try {
          const userDocRef = doc(db, "users", currentUser.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            setUserPhoneNumber(userDoc.data().phone_number);  // Store user phone_number in state
          } else {
            console.error("No such document!");
          }
        } catch (error) {
          console.error("Error fetching user number:", error);
        }
      }
    };

    fetchUserPhoneNumber();
  }, [currentUser]);

  // Remove the useContext call since we're now receiving the functions as props

  // Modify the handleClose function to use the passed functions
  const handleClose = () => {
    if (typeof setIsPhoneAgentMode === 'function') {
      setIsPhoneAgentMode(false);
    }
    if (typeof setPhoneAgentInstructions === 'function') {
      setPhoneAgentInstructions("");
    }
    onClose(); // Call the original onClose function
  };

  if (!isVisible) return null;

  return (
    <div className="settingsModal-modal">
      <div className="settingsModal-content">
        <div className="settingsModal-header">
          <h2>Settings</h2>
          {/* Update the onClick handler for the close button */}
          <button type="button" className="settingsModal-close-button" onClick={handleClose}>&times;</button>
        </div>
        <div className="settingsModal-body">
          <ul className="settingsModal-tabs">
            <li className={tab === 'profile' ? 'active' : ''} onClick={() => setTab('profile')}>
              Profile
            </li>
            <li className={tab === 'contacts' ? 'active' : ''} onClick={() => setTab('contacts')}>
              Contacts
            </li>
            <li className={tab === 'settings' ? 'active' : ''} onClick={() => setTab('settings')}>
              Settings
            </li>
            <li className={tab === 'speech' ? 'active' : ''} onClick={() => setTab('speech')}>
              Speech
            </li>
            <li className={tab === 'callHistory' ? 'active' : ''} onClick={() => { setTab('callHistory'); setHistoryFilter(null); }} style={{ lineHeight: '1.2' }}>
              <div>Call</div>
              <div>History</div>
            </li>
            <li className={tab === 'flagged' ? 'active' : ''} onClick={() => setTab('flagged')} style={{ lineHeight: '1.2' }}>
              <div>Flagged</div>
              <div>Calls</div>
            </li>
            <li className={tab === 'legal' ? 'active' : ''} onClick={() => setTab('legal')}>
              Legal
            </li>
          </ul>
          <div className="settingsModal-tab-content">
            {tab === 'profile' && <Profile currentUser={currentUser} onClose={onClose} />}
            {tab === 'settings' && <div>General Settings</div>}
            {tab === 'speech' && <div>Speech Settings</div>}
            {tab === 'contacts' && (
              <Contacts
                currentUser={currentUser}
                userPhoneNumber={userPhoneNumber}
                onClose={onClose}
                isPhoneAgentMode={isPhoneAgentMode}
                setPhoneAgentInstructions={setPhoneAgentInstructions}
                onViewHistory={(contactName) => {
                  setTab('callHistory');
                  setHistoryFilter(contactName);
                }}
              />
            )}
            {tab === 'callHistory' && (
              <CallHistory
                currentUser={currentUser}
                filterContactName={historyFilter}
                onBack={() => {
                  setHistoryFilter(null);
                  setTab('contacts');
                }}
              />
            )}
            {tab === 'flagged' && (
              <FlaggedCalls currentUser={currentUser} />
            )}
            {tab === 'legal' && (
              <Legal currentUser={currentUser} />
            )}
            </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
